// extracted by mini-css-extract-plugin
export default {"wrap":"CustomActivityIndicator_wrap__jllRr","indicator":"CustomActivityIndicator_indicator__Gvqg+"};